import type { WalkerStripeConnectGetReirectUrlResponse } from "wagAPI";
import type { GetWalkerStripeConnectRedirectUrlParsedResponse } from "webApp";
export const getWalkerStripeConnectRedirectUrlResponseParser = (response: WalkerStripeConnectGetReirectUrlResponse): GetWalkerStripeConnectRedirectUrlParsedResponse => ({
  isPayable: response.is_payable,
  stripeRedirectUrl: response.stripe_redirect_url
});
export default getWalkerStripeConnectRedirectUrlResponseParser;